import React, { Component } from 'react';
import api from '../../../api/index.js';

class RemoveRowForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			text: ''
		};
	}
	
	onChange = (e) => {
		this.setState({[e.target.name]: e.target.value});
	}
	
	onSubmit = async (e) => {
		e.preventDefault();
		try {
			const rows = this.parse(this.state.text);
			let r = await api.post('farms/' + this.props.FarmID + '/fields/' + this.props.FieldID + '/rows/' + this.props.mode, {'rowdata': JSON.stringify(rows)});
			api.success('Rows ' + this.props.mode + 'd', r);
			if (this.props.onRemoved)
				this.props.onRemoved(r);
		} catch(e) {
			api.handleExceptions(e);
		}
	}
	
	
	parse(text) {
		text = text.trim();
		if (text.length === 0)
			throw new Error("Please supply some rows to discontinue.");
		const lines = text.split("\n");
		let rows = [];
		for(let i=0; i < lines.length; i++) {
			let line = lines[i].trim();
			const rowchunks = line.trim().split(',');
			
			for(let t=0; t < rowchunks.length; t++) {
				const r = rowchunks[t].trim().split('-');
				if (r.length === 1) { // it's just one row
					rows.push(r[0].trim());
				} else { // it's a sequence
					for(let j = parseInt(r[0]); j <= parseInt(r[1]); j++) {
						rows.push(j);
					}
				}
				
			}
		}
		return rows;
	}
	
	

	
	render() {
		console.log(this.props);
		return (
			<div>
				<form onSubmit={this.onSubmit}>
					<label>Row data</label>
					<p>You can specify row as one row, a list of rows separated by commas, or a range with a dash.</p>
					<textarea value={this.state.text} name="text" onChange={this.onChange} />
					<p>Examples:</p>
					<ul>
						<li>1-10 <small>(rows 1 to 10)</small></li>
						<li>12 <small>(row 12)</small></li>
						<li>23,24 <small>(rows 23 and 24)</small></li>
					</ul>
					<p>Or any combination therein.</p>
					<input type="submit" value={this.props.mode.toString().toUpperCase() + " rows"} />
				</form>
			</div>
		);
	}
}

export default RemoveRowForm;
